import { FC, useEffect, useRef } from 'react';
import { usePostHog } from '@posthog/react';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { getClassSelectionScope } from '../../experiments/TEAMF-824/classSelectionScope';
import {
  selectedTeacherDashboardFilter,
  setTeacherDashboardFilter,
} from '../../redux/reducers/teacherDashboardFiltersSlice';
import { useGlobalClassFilter } from '../../custom-hooks/useGlobalClassFilter';
import { selectedReportsFilter, setReportsFilter } from '../../redux/reducers/filterReportsSlice';
import { Class } from '../../models/Class';

const GlobalClassFilterSync: FC = () => {
  const dispatch = useAppDispatch();
  const posthog = usePostHog();
  const { classes: availableClasses, selectedClasses } = useGlobalClassFilter();
  const dashboardFilter = useAppSelector(selectedTeacherDashboardFilter);
  const reportsFilter = useAppSelector(selectedReportsFilter);

  const dashboardFilterRef = useRef(dashboardFilter);
  dashboardFilterRef.current = dashboardFilter;
  const reportsFilterRef = useRef(reportsFilter);
  reportsFilterRef.current = reportsFilter;

  useEffect(() => {
    if (!selectedClasses.length) return;

    posthog?.register({
      class_selection: getClassSelectionScope(selectedClasses.length, availableClasses.length),
      class_count: selectedClasses.length,
    });
  }, [posthog, selectedClasses, availableClasses]);

  useEffect(() => {
    const classes = selectedClasses.map(cls => ({ id: cls.id, name: cls.name }));
    const current = dashboardFilterRef.current;
    const unchanged =
      current.classes?.length === classes.length && classes.every((cls, i) => current.classes?.[i]?.id === cls.id);

    if (unchanged) return;

    dispatch(setTeacherDashboardFilter({ ...current, classes }));
  }, [selectedClasses, dispatch]);

  useEffect(() => {
    const classes = selectedClasses.map(cls => ({ id: cls.id, name: cls.name })) as Class[];
    const current = reportsFilterRef.current;
    const unchanged =
      current.classes?.length === classes.length && classes.every((cls, i) => current.classes?.[i]?.id === cls.id);

    if (unchanged) return;

    dispatch(setReportsFilter({ ...current, classes }));
  }, [selectedClasses, dispatch]);

  return null;
};

export default GlobalClassFilterSync;
